import { TimelineCell } from 'shared/types/models';
import { styleForCellWithTimelinePlacement } from 'shared/constants';

export function getTimelineCellStyle(cell: TimelineCell): React.CSSProperties | null {
  if (cell.kind === 'timeline' && cell.periodType !== 'none') {
    return styleForCellWithTimelinePlacement;
  }
  return null;
}
